export default __webpack_public_path__ + "static/media/basicsEpa.f322f35d.jpg";